import { useEffect, useMemo } from 'react';
import { useCoreLoopConfigurationStore } from '@core/coreLoopConfiguration/useCoreLoopConfigurationStore';
import { useTenantId } from '@/contexts/TenantContext';
import type { CoreLoopConfigAccess } from '@/config/portalRoutes.config';

/** Loads the tenant's core loop configuration for route and menu gating. */
const useCoreLoopConfigAccess = (): CoreLoopConfigAccess => {
  const tenantId = useTenantId();
  const ensureCoreLoopConfiguration = useCoreLoopConfigurationStore(
    (state) => state.ensureCoreLoopConfiguration,
  );
  const status = useCoreLoopConfigurationStore(
    (state) => state.coreLoopConfigurationStatus,
  );
  const items = useCoreLoopConfigurationStore(
    (state) => state.coreLoopConfigurationItems,
  );

  useEffect(() => {
    if (tenantId) {
      void ensureCoreLoopConfiguration(tenantId);
    }
  }, [tenantId, ensureCoreLoopConfiguration]);

  return useMemo(() => ({ status, items }), [status, items]);
};

export default useCoreLoopConfigAccess;
